import createCollectionsApi from './api'

import {
  createSchema,
  createSinglesSchema,
  updateSchema,
  removeSchema,
  restoreSchema,
} from './commands/operations'

import {
  setDisplayField,
  setDisplayName,
  setNamespace,
  setPermissions,
  setVersion,
  enablePlugin,
  disablePlugin,
  updatePlugin,
} from './commands/schemaProperties'

import {
  addField,
  updateField,
  markFieldDeleted,
  restoreField,
  deleteFieldPermanently,
} from './commands/fields'

import { TRANSLATABLE_FIELD_TYPES } from './plugins/multilingual'

import { PermissionRole } from '@wix/wix-data-schema-types'
import {
  Preset,
  PermissionsByPreset,
  getPermissionsByPreset,
  findPresetByPermissions,
} from './permissionsPresets'

import {
  CreateCollectionsApiParams,
  CollectionsApi,
  Patch,
  Patches,
  Transport,
} from './types'

const ROLES = {
  ADMIN: PermissionRole.admin,
  ANYONE: PermissionRole.anyone,
  SITE_MEMBER: PermissionRole.siteMember,
  SITE_MEMBER_AUTHOR: PermissionRole.siteMemberAuthor,
}

import { getCollectionType, CollectionType } from './helpers/collectionType'

export {
  createCollectionsApi,
  // schema operations
  createSchema,
  createSinglesSchema,
  updateSchema,
  removeSchema,
  restoreSchema,
  // schema properties commands
  setDisplayField,
  setDisplayName,
  setNamespace,
  setPermissions,
  setVersion,
  enablePlugin,
  disablePlugin,
  updatePlugin,
  // fields commands
  addField,
  updateField,
  markFieldDeleted,
  restoreField,
  deleteFieldPermanently,
  // permissions
  ROLES,
  Preset as PRESETS,
  PermissionsByPreset as PERMISSIONS_BY_PRESET,
  getPermissionsByPreset,
  findPresetByPermissions,
  // helpers
  getCollectionType,
  // types
  CreateCollectionsApiParams,
  CollectionsApi,
  CollectionType,
  Patch,
  Patches,
  Transport,
  // plugins
  TRANSLATABLE_FIELD_TYPES,
}
